import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import { KeyType } from '../../types';
import { ActionTemplate } from './action-template.types';

@Component({
  selector: 'cohrex-action-template',
  templateUrl: './action-template.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ActionTemplateComponent {
  private _actions: string[] = [];
  @Input()
  set actions(value: string[]) {
    this._actions = value;
  }
  get actions(): string[] {
    return this._actions;
  }

  private _actionTemplates: ActionTemplate[] = [];
  @Input()
  set actionTemplates(value: ActionTemplate[]) {
    this._actionTemplates = value;
  }
  get actionTemplates(): ActionTemplate[] {
    return this._actionTemplates;
  }

  private _tableItem: any;
  @Input()
  set tableItem(value: any) {
    this._tableItem = value;
  }
  get tableItem(): any {
    return this._tableItem;
  }

  @Output()
  actionTriggered: EventEmitter<{ data: KeyType; action: string }> =
    new EventEmitter();

  handleActionClicked(event: Event, template: ActionTemplate) {
    const target = event.target as HTMLButtonElement;
    const tableRow = target?.closest('tr');
    const data = JSON.parse(tableRow?.getAttribute('data')!);
    template?.action({ data, action: template.type ?? '' });
  }
}
